if (!customElements.get('a2l-feature-preview')) {
  customElements.define('a2l-feature-preview', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.content = this.querySelector('[data-feature-content]');
        this.button = this.querySelector('button');
        if (!this.content || !this.button) return;
        this.expanded = false;
        this.button.onclick = () => {
          this.expanded = !this.expanded;
          this.update();
        };
        this.update();
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.content);
      });
    }

    update() {
      const previewHeight = parseFloat(getComputedStyle(this.content).fontSize) * 7;
      const hasOverflow = this.content.scrollHeight > previewHeight + 1;
      this.toggleAttribute('data-collapsed', hasOverflow && !this.expanded);
      this.button.hidden = !hasOverflow;
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.button.querySelector('[data-feature-label]').textContent = this.expanded ? 'Ver menos' : 'Ver más';
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
    }
  });
}
